import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { updateBrokerConnectDataWithoutSave } from '@actions/brokerConnect/brokerConnectActionCreators';
import { connect } from 'react-redux';

import Hours from './Hours';
import ErrorMessage from './ErrorMessage';

import { ACTIVITY_TYPES } from '@constants/common/statusTypes';
import { CLOSED, SELECT } from '@constants/common/dateTimeValues';

const Days = props => {
   
    const { brokerAvailabilities, updateHandler, status, closedBtnHandler, actions } = props;
    const disabled = status === ACTIVITY_TYPES.INACTIVE ? true : false;

    //if brokerAvailabilities array is empty
    const brokerSchedule = [ ...brokerAvailabilities ];
    while (brokerSchedule.length < 7) {
        const keyAndValue = {
            '0': 'Monday',
            '1': 'Tuesday',
            '2': 'Wednesday',
            '3': 'Thursday',
            '4': 'Friday',
            '5': 'Saturday',
            '6': 'Sunday'
        };   

        brokerSchedule.push({ day: keyAndValue[brokerSchedule.length], toTime: SELECT, fromTime: SELECT });
    } 

    if(brokerAvailabilities.length < 7) {
        actions.updateBrokerConnectDataWithoutSave({ ...props, brokerAvailabilities: brokerSchedule });
    }

    const BrokerAvail = () => {
        return brokerSchedule.map( (fullDay, i) => {
            const { day, fromTime, toTime } = fullDay;
            const isClosed = fromTime === CLOSED || toTime === CLOSED;

            return (
                <Fragment key={day}>
                    <div className="week__content grid-col-12">
                        <div className="grid-row day-container">
                            <div className="mobile:grid-col-12 tablet:grid-col-2 day_weekday">{day}</div>
                            <div className="mobile:grid-col-12 tablet:grid-col-3 day_select">
                                <Hours { ...props } type="fromTime" day={ day } time={ fromTime } index={ i } updateHandler={ updateHandler } isDisabled={ disabled || isClosed } />
                            </div>
                            <div className="mobile:grid-col-12 tablet:grid-col-1 day_to"><div className="text-center">To</div></div>
                            <div className="mobile:grid-col-12 tablet:grid-col-3 day_select">
                                <Hours { ...props } type="toTime" day={ day }  time={ toTime } index={ i } updateHandler={ updateHandler } isDisabled={ disabled || isClosed } />
                            </div>
                            <div className="mobile:grid-col-12 tablet:grid-col-2 day_close">
                                <div className="gi-component margin-top-105">
                                    <input id={`close__${day}`}  className="usa-checkbox__input gi-checkbox__input" type="checkbox" defaultChecked={ isClosed } disabled={ disabled } onClick={ e => closedBtnHandler( e, day, i ) } />
                                    <label htmlFor={`close__${day}`} className="usa-checkbox__label gi-checkbox__label">Closed</label>
                                </div>
                            </div>
                        </div>
                        <div className="grid-row day-error-container">
                            {
                                fromTime > toTime && !( fromTime === SELECT || toTime === SELECT ) &&
                                <ErrorMessage message="brokerconnect.days.error_msg.start_time" />
                            }
                            {
                                fromTime !== CLOSED && fromTime === toTime && !( fromTime === SELECT || toTime === SELECT ) &&
                                <ErrorMessage message="brokerconnect.days.error_msg.invalid_same_time" />
                            }
                        </div>
                    </div>
                </Fragment>
            );     
        });
    };
        
    return (
        <BrokerAvail />
    );
  
};

const matchDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        updateBrokerConnectDataWithoutSave
    }, dispatch)
});

export default connect(null, matchDispatchToProps)(Days);